import { env } from './env'

export const isProd = env.NODE_ENV === 'production'
export const isDev = env.NODE_ENV === 'development'
export const isTest = env.NODE_ENV === 'test'

/*
 * The flags below were server variables or their `VITE_AGENT_*` twins. The
 * server's never reach this bundle and no deployment sets the twins, so each
 * is the value it always evaluated to here.
 */
export const isBillingEnabled = false
export const isSlackExtendedScopesEnabled = false
export const isOllamaConfigured = false
export const isInvitationsDisabled = false
export const isPublicApiDisabled = false
